var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuobi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#060B2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M18.332 11.961c0-3.01-1.45-5.603-2.562-6.452 0 0-.077-.047-.077.077-.093 5.82-3.041 7.41-4.678 9.524-3.75 4.909-.262 10.28 3.288 11.269 1.992.555-.463-.988-.771-4.23-.37-3.936 4.8-6.93 4.8-10.188"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3489EE",
    d: "M20.277 13.952c-.015-.015-.046-.015-.077 0l-.015.016c-.062.725-.865 2.3-1.868 3.735-3.412 4.878-1.467 7.225-.37 8.49.632.741 0 0 1.59-.756.123-.062 3.087-1.636 3.41-5.202.325-3.473-1.882-5.65-2.67-6.283"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobi);
export default __webpack_public_path__ + "static/media/Huobi.da18cdb3.svg";
export { ForwardRef as ReactComponent };